import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';

export const StyledModalBody = styled(Modal.Body)`
  padding: 64px 33px 0 33px ;
`;

export const StyledParagraph = styled.p`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 154%;
  text-align: center;
  color: #4F5388;
  margin-bottom: 43px;
  margin-top: 50px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
